import { createContext } from "react";

const searchContext = createContext({
  keyword: "",
  filters: [],
  priceRange: null,
  showMobileSearchInput: false,
  addKeyword: (key) => {},
  addFilters: (filterTag) => {},
  removeFilter: (filterTag) => {},
  setFilters: (filters) => {},
  setPriceRange: (priceRange) => {},
  setShowMobileSearchInput: (test) => {},
  resetAllSearch: () => {},
});

export default searchContext;
